var baseUrl = "";
// liveUrl

// var stripeScretKey= "sk_test_51N6rHfJs3dhE24kFfCv4ciCKPoPss1pCjlaYVAD3UIx4hl2ai89La6yMaRR6vdSh0baEyQHPSaCsab9KCRDUSmcJ00hfahKZHi";
// var stripePublicKey = "pk_test_51N6rHfJs3dhE24kFDTPd4npEeV86St8z3whTB8j8lPrWTntKLx7LVzvMlYc1z81jAAhcVS2hXgCPECWw8nohIVW400oD1WZcTP";
var stripeScretKey =
  "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";
var stripePublicKey =
  "pk_live_51N6rHfJs3dhE24kFGGuqSA9GqIUMZ1XUg0qyMePg9sGNr84aumYCTZqkU90sWzPoiFsV1ZGP5GFOufqPBV83U0Hr00PUoa8eUG";

// var callBackBaseUrl = "https://demoweb.cryptowiretest.com/#/login";
// var callLogoutUrl = "https://demoweb.cryptowiretest.com/#/logout";
// var baseurlMain = "https://demoweb.cryptowiretest.com/";
var callBackBaseUrl = "https://3-verse.io/#/login";
var callLogoutUrl = "https://3-verse.io/#/logout";
var baseurlMain = "https://3-verse.io/";

if (
  window.location.hostname === "192.168.1.20" ||
  window.location.hostname === "192.168.1.80" ||
  window.location.hostname === "192.168.1.9" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "localhost" ||
  window.location.hostname === "192.168.1.62" ||
  window.location.hostname === "192.168.1.72"
) {
  baseUrl = "http://" + window.location.hostname + ":7000/";
} else {
  baseUrl = "https://vtgapi.3-verse.io/";
  // baseUrl = "https://uatvtgapi.cryptowiretest.com/";
  // callBackBaseUrl = "http://demoweb.cryptowiretest.com/#/login";
  // callLogoutUrl = "http://vtgapi.cryptowire.in/#/logout";
}

capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
console.log(baseUrl, "base url ");
export var baseUrl;
export var callBackBaseUrl;
export var callLogoutUrl;
export var capitalize;
export var baseurlMain;
export var stripePublicKey;
export var stripeScretKey;
